import { ChangeDetectionStrategy, Component, EventEmitter, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PositionAndRotation } from '@3d-scene/model3d/global-container';
import { Euler, Vector3 } from 'three';
import { MathUtils } from '@3d-scene/common/util/math-utils';

@Component({
  selector: 'app-move-coordinate-center',
  imports: [
    FormsModule,
    TranslateModule,
  ],
  templateUrl: './move-coordinate-center.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MoveCoordinateCenterComponent implements OnInit {
  public positionAndRotation: PositionAndRotation = {
    position: new Vector3(0, 0, 0),
    rotation: new Euler(0, 0, 0)
  };

  public finish: EventEmitter<{new: number, old: number}[]> = new EventEmitter<{new: number, old: number}[]>();

  public translationX: number = 0;
  public translationY: number = 0;
  public translationZ: number = 0;
  public rotationX: number = 0;
  public rotationY: number = 0;
  public rotationZ: number = 0;

  public ngOnInit() {
    this.translationX = - this.positionAndRotation.position.x;
    this.translationY = - this.positionAndRotation.position.y;
    this.translationZ = - this.positionAndRotation.position.z;
    this.rotationX = this.removeRoundingError(MathUtils.toDegrees(this.positionAndRotation.rotation.x));
    this.rotationY = this.removeRoundingError(MathUtils.toDegrees(this.positionAndRotation.rotation.y));
    this.rotationZ = this.removeRoundingError(MathUtils.toDegrees(this.positionAndRotation.rotation.z));
  }

  public cancel(): void {
    this.finish.emit([]);
  }

  public moveCoordinateCenter(): void {
    // Use negative translation values as we want to move the axis, not the 3D object
    this.finish.emit([
      {new: this.translationX, old: - this.positionAndRotation.position.x},
      {new: this.translationY, old: - this.positionAndRotation.position.y},
      {new: this.translationZ, old: - this.positionAndRotation.position.z},
      {new: MathUtils.toRadians(this.rotationX), old: this.positionAndRotation.rotation.x},
      {new: MathUtils.toRadians(this.rotationY), old: this.positionAndRotation.rotation.y},
      {new: MathUtils.toRadians(this.rotationZ), old: this.positionAndRotation.rotation.z},
    ]);
  }

  private removeRoundingError(value: number): number {
    return Number.parseFloat(value.toFixed(4));
  }
}
